export const FILE_NAME_KEY = "fileName";
export const FILE_SIZE_KEY = "fileSize";
export const FILE_DATA_KEY = "fileData";
export const IS_LOCAL_KEY = "IsLocal";
export const FILE_ATTACH_URL_KEY = "FileAttachURL";
